<template>
  <v-row>
    <v-col>
      <v-row dense>
        <v-col class="text-h5 gray--text"> Tonometria de Aplanação </v-col>
      </v-row>

      <v-row  
        v-if="!readOnly"
        dense>
        <v-col>
          <v-text-field
            label="Olho Direito"
            v-model="rightEyeValue"
            dense
            hide-details
            outlined
            background-color="white"
            persistent-placeholder
            placeholder=" "
            type="number"
          />
        </v-col>

        <v-col>
          <v-text-field
            label="Olho Esquerdo"
            v-model="leftEyeValue"
            dense
            hide-details
            outlined
            variant="outlined"
            background-color="white"
            placeholder=" "
            persistent-placeholder
            type="number"
          />
        </v-col>


        <v-col>
          <v-text-field
            label="Horário"
            v-model="examinedTime"
            dense
            hide-details
            @click="setTime"
            pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
            type="time"
            outlined
            background-color="white"
          />
        </v-col>
      </v-row>

      <v-row
        v-if="!readOnly"
        dense
        justify="end"
      >
        <v-col cols="auto">
          <v-btn
            dark
            color="light-blue"
            @click="saveTonometry"
          >
            Adicionar
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="lodash.isEmpty(applanationTonometries)"
        justify="center"
      >
        <v-col cols="6">
          <v-alert
            color="orange"
            outlined
            text
            type="info"
          >
            Lista de Tonometrias Vazia
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-row
          dense
          justify="space-around"
        >
          <v-col
            class="font-weight-bold"
            cols="3"
          > Olho direito </v-col>
          <v-col
            class="font-weight-bold"
            cols="3"
          > Olho esquerdo </v-col>
          <v-col
            class="font-weight-bold"
            cols="3"
          > Horário </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <v-col
          v-for="applanationTonometry in applanationTonometries"
          :key="applanationTonometry.id"
          cols="12"
          class="pa-0"
          justify="end"
        >
          <v-card class="pa-0">

            <v-alert
              class="pa-0"
              dense
              colored-border
              color="error"
              :border="warningValue(applanationTonometry.rightEyeValue, applanationTonometry.leftEyeValue) ? 'left' : null"
            >
              <v-container
                fluid
                class="pl-2"
              >
                <v-row justify="start">
                  <v-col cols="3"> {{ applanationTonometry.rightEyeValue }} mmhg</v-col>
                  <v-col cols="3"> {{ applanationTonometry.leftEyeValue }} mmhg</v-col>
                  <v-col cols="3"> {{ applanationTonometry.examinedTime }} </v-col>

                  <v-col cols="auto">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        v-if="!readOnly"
                          small
                          icon
                          :attrs="attrs"
                          v-on="on"
                          @click="deleteApplanationTonometry(applanationTonometry.id)"
                        >
                          <v-icon>eva-trash-outline</v-icon>
                        </v-btn>
                      </template>

                      <span> Excluir </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </v-alert>
          </v-card>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
import GET_APPLANATION_TONOMETRIES from "@/graphql/biomicroscopy/applanation_tonometry/applanation_tonometries.gql";
import SAVE_APPLANATION_TONOMETRY from "@/graphql/biomicroscopy/applanation_tonometry/save_applanation_tonometry.gql";
import DELETE_APPLANATIONTONOMETRY from "@/graphql/biomicroscopy/applanation_tonometry/delete_applanation_tonometry.gql";

export default {
  name: "ApplanationTonometry",
  props: {
    attendance: Object,
    readOnly: Boolean,
  },
  data() {
    return {
      rightEyeValue: "",
      leftEyeValue: "",
      examinedTime: "",
    };
  },

  apollo: {
    applanationTonometries: {
      query: GET_APPLANATION_TONOMETRIES,
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
  },
  methods: {
    setTime() {
      this.examinedTime = this.$moment().format("HH:mm");
    },
    validate() {
      this.allergySubstanceError = "";

      if (this.allergySubstance) {
        return true;
      }

      this.allergySubstanceError = "Esse campo deve ser preenchido.";
      return false;
    },
    warningValue(rightEye, leftEye) {
      if (
        leftEye < 10 ||
        leftEye > 20 ||
        rightEye < 10 ||
        rightEye > 20)
        return true

      return false
    },
    saveTonometry() {
      if (!this.rightEyeValue && !this.leftEyeValue) return;

      this.apolloMutate({
        mutation: SAVE_APPLANATION_TONOMETRY,
        variables: {
          attendanceId: this.attendance.id,
          rightEyeValue: parseInt(this.rightEyeValue),
          leftEyeValue: parseInt(this.leftEyeValue),
          examinedTime: this.examinedTime
        },
      }).then(() => {
        this.rightEyeValue = "";
        this.leftEyeValue = "";
        this.examinedTime = "";

        this.$apollo.queries.applanationTonometries.refetch();
      });
    },
    deleteApplanationTonometry(applanationTonometryId) {
      this.apolloMutate({
        mutation: DELETE_APPLANATIONTONOMETRY,
        variables: {
          applanationTonometryId: applanationTonometryId,
        },
      }).then(() => {
        this.$apollo.queries.applanationTonometries.refetch();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
